// Money helpers. All intermediate math stays unrounded; we round to cents only
// when a number becomes a dollar amount someone will see or be paid.

/** Rounds to cents, half away from zero, without floating-point surprises (1.005 -> 1.01). */
export function round2(x: number): number {
  if (!Number.isFinite(x)) throw new Error(`Cannot round non-finite amount: ${x}`);
  const cents = Math.round(Math.abs(Number((x * 100).toFixed(6))));
  return (Math.sign(x) * cents) / 100;
}

export function sum(values: number[]): number {
  return values.reduce((a, b) => a + b, 0);
}

/**
 * Splits a dollar total by percentages so the rounded pieces add back to the
 * exact total. The last piece absorbs the rounding penny.
 */
export function splitByPercent(total: number, percents: number[]): number[] {
  const pieces = percents.map((p) => round2((total * p) / 100));
  if (pieces.length > 0) {
    const drift = round2(round2(total) - sum(pieces));
    pieces[pieces.length - 1] = round2(pieces[pieces.length - 1]! + drift);
  }
  return pieces;
}
